import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Container, Grid, TextField, IconButton, Typography, Tooltip } from '@material-ui/core/';
import AppContainer from './AppContainer';
import { getHoliday, createHoliday, modifyHoliday, deleteHoliday } from '../actions/holidays';
import { Edit, Delete, Done, Close } from '@material-ui/icons';
import { isAdmin } from '../utils/authUtils';
import { mobileCheck } from '../utils/mobileCheck';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { dateToString } from '../utils/dateToString';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    paper: {
        padding: theme.spacing(2),
    },
    container: {
        padding: theme.spacing(mobileCheck() ? 0 : 4),
    },
    grid: {
        margin: '10px',
    },
    textField: {
        width: '100%',
    },
    button: {
        margin: theme.spacing(1),
    },
    typography: {
        margin: theme.spacing(1),
    },
}));

export default function Holiday(props) {
    const classes = useStyles();

    const [selectedDate, setSelectedDate] = React.useState(
        new Date()
    );

    const [originalObjectData, setOriginalObjectData] = React.useState({
        name: '',
        date: selectedDate.getTime(),
    });

    const [objectData, setObjectData] = React.useState({
        name: '',
        date: selectedDate.getTime(),
    });

    const [state, setState] = React.useState({
        loaded: false,
        create: false,
        edit: false,
        addNewType: false,
    })

    const [pageLoaded, setPageLoaded] = React.useState(false);

    /* eslint-disable*/
    useEffect(() => {
        if (pageLoaded) return;

        if (props.match.params.id)
            fetchData(props.match.params.id);
        else
            setState({ ...state, create: true, edit: true, loaded: true });
    }, []);
    /* eslint-enable*/

    async function fetchData(id) {
        const result = await getHoliday(id);

        if (!result.success) {
            if (result.message.error?.indexOf('Token') !== -1) props.tokenExpired();
            props.openSnack(result.message.error, 'error');

            return;
        }

        setObjectData(result.data);
        setOriginalObjectData(result.data);
        setSelectedDate(new Date(result.data.date));
        setPageLoaded(true);
    }

    function handleEdit() {
        setState({ ...state, edit: true });
    }

    function handleCancelEdit() {
        if (state.create) {
            props.history.push('/holidays');
            return;
        }

        setObjectData({ ...originalObjectData });
        setState({ ...state, edit: false });
    }

    async function handleDoneEdit() {
        let result = {};
        if (state.create) {
            result = await createHoliday(objectData);
            props.history.push('/holiday/' + result.data[0]._id);
            fetchData(result.data[0]._id);
        }
        else
            result = await modifyHoliday(objectData);

        if (!result.success) {
            if (result.message.error?.indexOf('Token') !== -1) props.tokenExpired();
            props.openSnack(result.message.error, 'error');

            return;
        }

        setOriginalObjectData({ ...result.data });
        setState({ ...state, edit: false, create: false });
    }

    function handleDateChange(date) {
        setSelectedDate(date);
        setObjectData({ ...objectData, date: new Date(date.toDateString()).getTime() });
    }

    function handleDeleteHoliday() {
        if (!state.create)
            props.openDialog("Confirmación", "Seguro que desea eliminar este feriado?", objectData, handleDeleteCallback);
        else
            props.history.push('/holidays');
    }

    async function handleDeleteCallback(confirmed, item) {
        if (!confirmed)
            return;

        const result = await deleteHoliday(item._id);
        if (!result.success) {
            if (result.message.error?.indexOf('Token') !== -1) props.tokenExpired();
            props.openSnack(result.message.error, 'error');
            return;
        }
        props.history.push('/holidays');
    }

    function handleChange(event) {
        setObjectData({
            ...objectData,
            [event.target.name]: event.target.value,
        });
    }

    return (
        <div>
            <AppContainer title={"Feriado"} history={props.history} content={
                <Container maxWidth="lg" className={classes.container}>
                    <Grid container spacing={3}>
                        {!mobileCheck() && <Grid item xs={1} className={classes.grid} />}
                        <Grid item xs={!mobileCheck() ? 10 : 12} className={classes.grid}>
                            <Grid container>
                                <Grid item className={classes.grid}>
                                    <Typography variant="h6" noWrap className={classes.typography}>
                                        Información
                                    </Typography>
                                </Grid>
                                <Grid item className={classes.grid}>
                                    {(isAdmin() && !state.edit) && <Tooltip title="Editar"><IconButton onClick={handleEdit}><Edit /></IconButton></Tooltip>}
                                    {state.edit && <Tooltip title="Cancelar"><IconButton onClick={handleCancelEdit}><Close /></IconButton></Tooltip>}
                                    {state.edit && <Tooltip title="Aceptar"><IconButton onClick={handleDoneEdit}><Done color="primary" /></IconButton></Tooltip>}
                                    {(isAdmin() && state.edit) && <Tooltip title="Eliminar"><IconButton onClick={handleDeleteHoliday}><Delete color="error" /></IconButton></Tooltip>}
                                </Grid>
                            </Grid>
                            <Paper className={classes.paper}>
                                <Grid container>
                                    <Grid item xs={8} className={classes.grid}>
                                        <TextField
                                            InputProps={{
                                                readOnly: !state.edit,
                                            }}
                                            label={'Nombre'}
                                            className={classes.textField}
                                            value={objectData.name}
                                            name={'name'}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={e => {
                                                if (!state.edit) return;
                                                handleChange(e);
                                            }}
                                        />
                                    </Grid>
                                    {state.edit ?
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <DatePicker
                                                autoOk
                                                orientation="landscape"
                                                variant="static"
                                                openTo="date"
                                                value={selectedDate}
                                                onChange={handleDateChange}
                                            />
                                        </MuiPickersUtilsProvider>
                                        :
                                        <Grid item xs={8} className={classes.grid}>
                                            <TextField
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                label={'Fecha'}
                                                className={classes.textField}
                                                value={dateToString(objectData.date)}
                                                name={'date'}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>}
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </ Container>
            } />
        </div>
    );
}
